import type { LocationInterventionsListProps } from "./location-interventions-list.type";

import InterventionsTable from "@/components/ListTable/InterventionsTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { TAB_KEYS } from "@/constants/TabKeys";
import {
  INTERVENTIONS_FILTERS,
  INTERVENTIONS_INCLUDES,
} from "@/entities/interventions";
import InterventionAddButton from "@/modules/intervention/intervention-add-button";
import { ListProvider } from "@/modules/list";

const LocationInterventionsList = ({
  location,
  loading,
}: LocationInterventionsListProps) => {
  return (
    <ListProvider
      endpoint="interventions"
      loading={loading}
      storageKey={STORAGE_KEYS.LOCATIONS_INTERVENTIONS}
      contextTabValue={TAB_KEYS.LOCATION_INTERVENTIONS}
      includes={[INTERVENTIONS_INCLUDES.USERS]}
      hiddenFilters={{
        [INTERVENTIONS_FILTERS.ASSET_LOCATION_ID]: location?.id ?? "",
      }}
    >
      <InterventionsTable
        showAssetColumn
        extraActions={
          <InterventionAddButton
            ancestors={location?.ancestors}
            shortButtonText
            loading={loading}
          />
        }
      />
    </ListProvider>
  );
};

export default LocationInterventionsList;
